'use client'
import React from 'react'

import { HeaderItems } from '~/utils/getHeaderItems'
import { AuthModalType } from '~/utils/hooks/useAuthModal'

import { Button } from '~/components/Button/Button'

// import { gt } from '~/lib/gt'
import styles from './AuthButtons.module.css'

type AuthButtonsProps = {
  buttonsTranslations: HeaderItems['buttons']
  setModalType: React.Dispatch<React.SetStateAction<AuthModalType | null>>
}

export function AuthButtons({ buttonsTranslations, setModalType }: AuthButtonsProps) {
  return (
    <div className={styles.authButtonsContainer}>
      <Button onClick={() => setModalType('login')} variant='ghost' className={styles.signButton} size='small'>
        {buttonsTranslations.signIn}
        {/* {gt.tp('Header', 'Sign in')} */}
      </Button>
      <Button onClick={() => setModalType('register')} className={styles.signButton} size='small'>
        {buttonsTranslations.signUp}
        {/* {gt.tp('Header', 'Sign up')} */}
      </Button>
    </div>
  )
}
